import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "uk-container uk-text-small" }
const _hoisted_2 = { class: "uk-flex" }
const _hoisted_3 = {
  key: 0,
  class: "uk-margin-top uk-padding-small"
}
const _hoisted_4 = {
  key: 1,
  class: "uk-margin-top uk-alert-danger uk-border-rounded uk-padding-small",
  role: "alert"
}
const _hoisted_5 = { class: "uk-margin-small-top" }
const _hoisted_6 = {
  key: 2,
  class: "uk-margin-top tw-text-left"
}
const _hoisted_7 = { class: "tw-text-left" }
const _hoisted_8 = { class: "tw-text-left tw-inline-block tw-w-[200px] tw-mb-1 tw-mr-1" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = {
  key: 0,
  class: "tw-bg-amber-300"
}
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "uk-button uk-button-danger print-button uk-align-right",
        href: "javascript:void(0)",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, "Close"),
      _createElementVNode("a", {
        class: _normalizeClass(["uk-button uk-button-primary print-button uk-align-right", { 'uk-disabled': !_ctx.iframeSrc || _ctx.isLoading }]),
        href: "javascript:void(0)",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.printPdf && _ctx.printPdf(...args)))
      }, "Print", 2)
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading print preview... "))
      : (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Unable to load print preview.", -1)),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createVNode(_component_Button, {
                isGreen: true,
                icon: "rotate-right",
                onClick: _ctx.loadPdf
              }, null, 8, ["onClick"]), [
                [_directive_tippy, {content: 'Re-generate PDF', placement: 'bottom'}]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userPromptFields, (field, fieldIdx) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (field.field_key.toLowerCase().includes('date'))
                    ? (_openBlock(), _createBlock(_component_DatePicker, {
                        key: 0,
                        autofocus: fieldIdx === 0,
                        class: "tw-inline-block",
                        textLabel: field.label,
                        "input-class": 'tw-rounded-lg tw-border tw-border-slate-900 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55',
                        format: "MM/DD/YYYY",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                        "value-type": "format",
                        "show-days-shortcuts": true,
                        "controls-placement": "popup",
                        onChange: _ctx.loadPdf
                      }, null, 8, ["autofocus", "textLabel", "modelValue", "onUpdate:modelValue", "onChange"]))
                    : (_openBlock(), _createElementBlock("label", _hoisted_9, [
                        _createTextVNode(_toDisplayString(field.label) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-900/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40",
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadPdf && _ctx.loadPdf(...args)))
                        }, null, 40, _hoisted_10), [
                          [_vModelText, field.value]
                        ])
                      ]))
                ]))
              }), 256))
            ]),
            (_ctx.printedDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Print started " + _toDisplayString(_ctx.printedDateFromNowString) + " (at " + _toDisplayString(_ctx.printedDate?.toLocaleTimeString()) + ")", 1))
              : _createCommentVNode("", true),
            _createElementVNode("iframe", {
              ref: "pdfFrame",
              src: _ctx.iframeSrc,
              style: {"width":"100%","height":"calc(100vh - 120px)","border":"1px solid #e5e7eb","border-radius":"8px"}
            }, null, 8, _hoisted_12)
          ]))
  ]))
}